module.exports = __webpack_public_path__ + "img/plb2.e949e860.jpeg";